import Vue from 'vue';

function setData(el, binding) {
  if (binding.value instanceof Array) {
    if (binding.value.length > 1) {
      el.store.img = binding.value;
      el.store.multi = true;
    } else {
      el.store.img = binding.value[0];
      el.store.multi = false;
    }
  } else {
    el.store.multi = false;
    el.store.img = binding.value;
  }
}

function clickPrev(e, el) {
  e.stopPropagation();
  if (el.store.index === 0) {
    el.store.index = el.store.img.length - 1;
  } else {
    el.store.index--;
  }
  el.store.imgEl.src = el.store.img[el.store.index];
}

function clickNext(e, el) {
  e.stopPropagation();
  if (el.store.index === el.store.img.length - 1) {
    el.store.index = 0;
  } else {
    el.store.index++;
  }
  el.store.imgEl.src = el.store.img[el.store.index];
}

/**
 * 图片大图展示
 * 例子：<img src="small.png" v-viewerer="large.png" alt="">
 */
Vue.directive('viewerer', {
  bind(el, binding) {
    const { store } = el;
    if (!store) {
      el.store = {
        img: '',
        multi: false,
        index: 0,
        btnEl: null,
        imgEl: null,
        leftBtn: null,
        rightBtn: null,
      };
    }

    let viewerContainer = document.querySelector('.image-viewer-container');
    if (!viewerContainer) {
      viewerContainer = document.createElement('div');
      viewerContainer.className = 'image-viewer-container';

      const imgEl = document.createElement('img');
      imgEl.setAttribute('alt', '');

      const arrowBtn = document.createElement('div');
      arrowBtn.className = 'arrow-btn';

      const leftBtn = document.createElement('i');
      leftBtn.innerHTML = '<i class="el-icon-arrow-left"></i>';
      leftBtn.className = 'arrow-btn-left';

      const rightBtn = document.createElement('i');
      rightBtn.innerHTML = '<i class="el-icon-arrow-right"></i>';
      rightBtn.className = 'arrow-btn-right';

      arrowBtn.appendChild(leftBtn);
      arrowBtn.appendChild(rightBtn);
      viewerContainer.appendChild(arrowBtn);
      viewerContainer.appendChild(imgEl);
      document.body.appendChild(viewerContainer);
      viewerContainer.addEventListener(
        'click',
        () => {
          viewerContainer.classList.remove('show');
        },
        false,
      );
    }

    el.store.btnEl = document.querySelector('.image-viewer-container .arrow-btn');
    el.store.imgEl = document.querySelector('.image-viewer-container img');
    el.store.leftBtn = document.querySelector('.image-viewer-container .arrow-btn .arrow-btn-left');
    el.store.rightBtn = document.querySelector('.image-viewer-container .arrow-btn .arrow-btn-right');
    setData(el, binding);

    el.clickShowImg = () => {
      if (el.store.multi) {
        // 获取当前图片index
        const siblings = el.parentNode.children;
        el.store.index = [].indexOf.call(siblings, el);
        el.store.btnEl.classList.add('show');

        el.store.leftBtn.onclick = (e) => {
          clickPrev(e, el);
        };
        el.store.rightBtn.onclick = (e) => {
          clickNext(e, el);
        };
      } else {
        el.store.btnEl.classList.remove('show');
      }
      el.store.imgEl.src = el.store.multi ? el.store.img[el.store.index] : el.store.img;
      viewerContainer.classList.add('show');
    };
    el.addEventListener('click', el.clickShowImg, false);
  },
  update(el, binding) {
    setData(el, binding);
  },
  unbind(el) {
    if (el.clickShowImg) {
      el.store = null;
      el.removeEventListener('click', el.clickShowImg, false);
    }
  },
});
